/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconColorProps} from '../types/types';
import useIconColor from './useIconColor';

/*
 * Defines the Design Language System (DLS) Side Nav Reports Icon component.
 *
 * ! NOTE: This Icon defines non-standard sizes within the DLS.
 *   https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
export const SideNavReportsIcon = ({color}: IconColorProps) => {
  const iconColor = useIconColor(color);
  return (
    <svg width={24} height={22} viewBox='0 0 24 22' fill='none'>
      <g clipPath='url(#prefix__clip0)' stroke={iconColor} strokeWidth={1.5}>
        <rect x={2} y={6.81} width={4.762} height={12.381} rx={0.5} />
        <path d='M10.262 3.5a.5.5 0 01.5-.5h3.762a.5.5 0 01.5.5v15.19a.5.5 0 01-.5.5h-3.762a.5.5 0 01-.5-.5V3.5zM18.523 10.166a.5.5 0 01.5-.5h3.762a.5.5 0 01.5.5v8.524a.5.5 0 01-.5.5h-3.762a.5.5 0 01-.5-.5v-8.524z' />
      </g>
      <defs>
        <clipPath id='prefix__clip0'>
          <path fill={iconColor} d='M0 0h24v22H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};
